import React, { memo } from 'react'
import { publisherSidebarLabels } from '../../data/Menu'
import PopulateMenu from './PopulateMenu'

const PublisherSection = ({ label, language, toggleMenu, advertiserId, menu, onUpdateSize, isApplicationsAvailable = false, reviewsRecords = 0 }) => {
    const title = publisherSidebarLabels[label][language]

    return (
        <div className="nav-group show">
            <div className="nav-label" onClick={toggleMenu}>
                {title}
            </div>
            <PopulateMenu menuItems={menu} advertiserId={advertiserId} onUpdateSize={onUpdateSize} language={language} isApplicationsAvailable={isApplicationsAvailable} reviewsRecords={reviewsRecords} />
        </div>
    )
}

export default memo(PublisherSection)
